export default __webpack_public_path__ + "static/media/icon_water.2e25d09e.svg";